<template>
  <div class="brand-card is-shadow-box is-shadow-box--hover">
    <div class="brand-name">{{ brand.name }}</div>
    <div class="brand-data">
      <div class="brand-data__logo">
        <img v-if="brand.brand_logo" :src="brand.brand_logo" :alt="brand.name">
        <div v-else class="no-logo">
          <div>
            <!-- <font-awesome-icon :icon="'fa-regular fa-file-circle-plus'" /><br> -->
            {{ $gettext('No logo') }}<br>
            <span class="click-to-add">{{ $gettext('Click to add') }}</span>
          </div>
        </div>
      </div>
      <div class="brand-data__details">
        <ul class="">
          <li class=""><span class="">{{ brand.brand_email }}</span></li>
          <li class=""><span class="">{{ brand.brand_address }}</span></li>
          <li class=""><span class="">{{ brand.brand_postal_code }}</span></li>
          <li class=""><span class="">{{ brand.brand_city }} {{ brand.brand_country }}</span></li>
        </ul>
        <!-- <ul class="">
          <li class=""><span>{{ brand.label_0 }}</span> <span>{{ brand.field_0 }}</span></li>
          <li class=""><span>{{ brand.label_1 }}</span> <span>{{ brand.field_1 }}</span></li>
          <li class=""><span>{{ brand.label_2 }}</span> <span>{{ brand.field_2 }}</span></li>
          <li class=""><span>{{ brand.label_3 }}</span> <span>{{ brand.field_3 }}</span></li>
          <li class=""><span>{{ brand.label_4 }}</span> <span>{{ brand.field_4 }}</span></li>
          <li class=""><span>{{ brand.label_5 }}</span> <span>{{ brand.field_5 }}</span></li>
        </ul> -->
      </div>
      
    </div>
    
  </div>
</template>

<script>
import LogoBrand from "@/components/brands/LogoBrand"

export default {
  name: 'BrandCard',
  components: {
    LogoBrand,
  },
  props: {
    brand: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .brand-card {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    position: relative;
    align-items: center;
    overflow: hidden;
    background: white;
    padding: 1rem;
    cursor: pointer;
    .brand-name {
      font-size: 20px;
      font-family: 'DINNextLTPro-Medium';
      width: 100%;
    }
    .brand-data {
      display: flex;
      gap: 1rem;
      width: 100%;
      &__logo {
        width: 150px;
        height: 150px;
        position: relative;
        // border-radius: $radiusMd;
        // overflow: hidden;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: top;
        }
        .no-logo {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: $inputBackgroundColor;
          text-align: center;
          font-size: 14px;
          .svg-inline--fa {
            color: $colorTextSemi;
            opacity: 0.3;
            font-size: 22px;
          }
          .click-to-add {
            color: $colorTextSemi;
          }
        }
      }
      
      &__details {
        height: 100%;
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
          font-size: 1rem;
          height: 100%;
          overflow-y: auto;
        }
      }
    }

    
  }
</style>